export const stepPathMap: Record<string, number> = {
  '/data_entry/entity_maintaining_registry': 0,
  '/data_entry/entity': 1,
  '/data_entry/branch': 2,
  '/data_entry/function': 3,
  '/data_management/ict_systems': 4,
  '/data_management/data': 5,
  '/data_entry/third_party_provider': 6,
  '/data_entry/currency_and_costs': 7,
  '/data_entry/contractual_information': 8,
  '/data_entry/ict_service': 9,
};
